import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locale/en/translation.json'
import is from './locale/is/translation.json'

i18n.use(initReactI18next).init({
  interpolation: {
    escapeValue: false
  },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['is', 'en'],
  keySeparator: false,
  nsSeparator: false,
  debug: false,
  resources: {
    en: { translation: en },
    is: { translation: is },
  },
  react: {
    useSuspense: false,
  },
})

export default i18n
